<hcf-popup-map #popupMapComponent [placesForMap]="placesForPopupMap" [latitude]="latitude" [longitude]="longitude">
</hcf-popup-map>
<div
  class="container"
  infinite-scroll
  [infiniteScrollDistance]="2"
  [infiniteScrollUpDistance]="0"
  [infiniteScrollThrottle]="600"
  (scrolled)="getDataScroll()">
  <div class="order-display">
    <div
      [ngClass]="{
        'search-results-map': true,
        'mobile-map-expanded': mobileMapExpanded,
      }">
      <h1 class="map-heading" (click)="toggleMap()"><span>View map</span></h1>
      <!--ngIf is needed otherwise map is not initialised when hidden with css by default-->
      <div (click)="openPopupMap(null)" class="map-popup-btn" *ngIf="!mobileMapExpanded"></div>
      <hcf-map
        [places]="placesForMap"
        [latitude]="latitude"
        [longitude]="longitude"
        [isPopup]="false"
        id="map-toggle-panel"
        *ngIf="!mobileMapExpanded">
      </hcf-map>
    </div>

    <div class="search-results-heading">
      <h1>
        <span>{{ searchTermDisplay }}</span>
      </h1>
    </div>

    <div *ngIf="displayTotals" class="reminder-content-ap">
      <div class="reminder-content-ap-container">
        <div>
          <span class="ic-status-affiliated"></span>
        </div>
        <div class="reminder-content-ap-content">
          <div *ngIf="selectedFilterType === filterType.people">
            <div>
              <strong> Affiliated Provider (AP) </strong>
            </div>
            <div>
              Affiliated Providers are contracted with us to perform certain healthcare services at certain healthcare
              facilities. Click the
              <strong>"Check services"</strong> button on a search result to see what healthcare services are available
              and where they can be performed.
            </div>
          </div>
          <div *ngIf="selectedFilterType === filterType.places">
            <div>
              <strong> Affiliated Provider (AP) healthcare facilities </strong>
            </div>
            <div>
              Some Affiliated Providers are only contracted with us to perform certain healthcare services at certain
              healthcare facilities. Clicking the <strong>"View facility details"</strong> button on a result below will
              show you all the healthcare services and APs available at that healthcare facility.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="search-results-container">
    <div
      [ngClass]="{
        'search-filters': true,
        'filters-expanded': searchFiltersPanelExpanded,
      }"
      aria-hidden="true">
      <h1 class="search-filters-heading" (click)="toggleSearchFiltersPanel()">
        <span>Search filters</span>
      </h1>
      <div id="search-filter-toggle-panel">
        <div class="filter-buttons">
          <button
            (click)="setFilterType(filterType.people, true)"
            [ngClass]="{
              'filter-person': true,
              selected: selectedFilterType == filterType.people,
            }">
            People
            <span *ngIf="profileTotals"> ({{ profileTotals.peopleTotals.total }})</span>
          </button>
          <button
            (click)="setFilterType(filterType.places, true)"
            [ngClass]="{
              'filter-place': true,
              selected: selectedFilterType == filterType.places,
            }">
            Places
            <span *ngIf="profileTotals"> ({{ profileTotals.placesTotals.total }})</span>
          </button>
        </div>
        <h2 class="filter-heading">
          Providers
          <span class="ic-who-can-help-me">
            <a (click)="showFilterHelp()" class="reset-service-filter"> Healthcare provider types</a>
          </span>
        </h2>
        <label
          *ngIf="displayTotals"
          [ngClass]="{
            'chk-label ap-filter': true,
            checked: affiliatedProvider,
          }">
          <input
            #filterAP
            type="checkbox"
            [disabled]="isLoading"
            [ngModel]="affiliatedProvider"
            (change)="setFilterAP(filterAP.checked)" />
          <span
            class="chk-text"
            title="An Affiliated Provider will organise prior approval with
 us and claim on your behalf for eligible healthcare
 services - so you don't need to submit a claim. You
 may need to see an Affiliated Provider in order to be
 covered under your policy. Click the 'Who can I find
 here?' link for more information."
            >Affiliated Providers</span
          >
          <!-- <span class="totals">({{displayTotals.affiliatedProvider}})</span> -->
        </label>
        <div *ngIf="selectedFilterType == filterType.people">
          <div class="indent-line"></div>
          <label
            *ngIf="displayTotals"
            style="margin-left: 30px"
            [ngClass]="{
              'chk-label ap-consult-filter': true,
              checked: affiliatedProviderConsult,
              opacity: !affiliatedProvider,
              disabled: !affiliatedProvider,
            }">
            <input
              #filterAPConsult
              type="checkbox"
              [disabled]="!affiliatedProvider"
              [ngModel]="affiliatedProviderConsult"
              (change)="setFilterAPConsult(filterAPConsult.checked)" />
            <span
              class="chk-text"
              title="An Affiliated Provider who performs specialist
consultations. Please check their profile to ensure they
offer the specific healthcare service or consultation
you need. If you're unable to find an Affiliated
Provider near you that offers the healthcare service
you need, please contact us. This is important for
Affiliated Provider only healthcare services."
              ><span style="padding-left: 45px">Provides consultations</span></span
            >
            <!-- <span class="totals">({{displayTotals.affiliatedProviderConsult}})</span> -->
          </label>
          <div class="indent-line"></div>
          <label
            *ngIf="displayTotals"
            style="margin-left: 30px"
            [ngClass]="{
              'chk-label telehealth-filter': true,
              checked: telehealth,
              opacity: !affiliatedProvider,
              disabled: !affiliatedProvider,
            }">
            <input
              #filterTelehealth
              type="checkbox"
              [disabled]="isLoading"
              [ngModel]="telehealth"
              (change)="setFilterTelehealth(filterTelehealth.checked)" />
            <span
              class="chk-text"
              title="An Affiliated Provider who performs specialist initial
and follow-up consultations via telehealth. A telehealth
consultation is the use of video or phone to deliver
healthcare consultations when Southern Cross patients
and Affiliated Providers are in different physical
locations and when no physical examination is required.
Please ensure that you have a good internet connection
and are in a quiet, private place. The Affiliated Provider
will direct you further on how to conduct the
telehealth consultation.">
              <span>Virtual consultations</span></span
            >
            <!-- <span class="totals">({{displayTotals.telehealth}})</span> -->
          </label>
        </div>
        <label *ngIf="displayTotals" [ngClass]="{ 'chk-label ec-filter': true, checked: easyClaim }">
          <input
            #filterEC
            type="checkbox"
            [disabled]="isLoading"
            [ngModel]="easyClaim"
            (change)="setFilterEC(filterEC.checked)" />
          <span
            class="chk-text"
            title="Easy-Claim is a convenient way for Southern Cross
 members to claim for eligible day-to-day healthcare
 services at participating partners at the time of
 purchase. Click the 'Who can I find here?' link for
 more information."
            >Easy-Claim partners</span
          >
          <!-- <span class="totals">({{displayTotals.easyClaim}})</span> -->
        </label>
        <div *ngIf="shouldShowSlider()" class="distance-panel">
          <label [ngClass]="{ 'chk-label': true, checked: distance }">
            <input
              #filterDistance
              type="checkbox"
              [disabled]="isLoading"
              [ngModel]="distance"
              (change)="setFilterDistanceKms(filterDistance.checked)" />
            <span class="chk-text" title="">Include nearby locations</span>
          </label>
          <div class="distance-slider">
            <div class="slider-title"> Within {{ distanceKms }}{{ distanceKms === 0 ? 'km' : 'kms' }} </div>
            <div style="display: flex">
              <div class="slider-text start">{{ matSlider.min }}</div>
              <div style="flex: 1; display: flex">
                <mat-slider #matSlider min="10" max="150" step="1">
                  <input matSliderThumb [(ngModel)]="distanceKms" (valueChange)="onDistanceChange($event)" />
                </mat-slider>
              </div>
              <div class="slider-text end">{{ matSlider.max }}kms</div>
            </div>
          </div>
        </div>
        <h2>
          <span class="cursor" (click)="toggleServiceCategory(serviceCategoryDisplay)">
            Services
            <span
              [ngClass]="{
                arrow_up: serviceCategoryDisplay,
                arrow_down: !serviceCategoryDisplay,
              }"
              *ngIf="
                (serviceCategorySearchTerm && displayServiceCategory) ||
                (!serviceCategorySearchTerm &&
                  displayTotals &&
                  displayTotals.serviceCategoryTotals &&
                  displayTotals.serviceCategoryTotals.length > 0)
              "></span>
          </span>
          <a (click)="resetFilter()" class="reset-service-filter" *ngIf="resetAvailable">Reset</a>
        </h2>
        <div class="selected-service-category-filter" *ngIf="hasResults && serviceCategoryDisplay">
          <ul *ngIf="serviceCategorySearchTerm && displayServiceCategory" class="plain-list">
            <li *ngIf="!serviceSearchTerm && !serviceCategorySearchTerm" class="selected-category">
              {{ serviceCategorySearchTerm }}
            </li>
            <a *ngIf="!resetAvailable">
              <span class="selected-category">{{ serviceCategorySearchTerm }}</span>
            </a>
            <a *ngIf="resetAvailable" (click)="unsetService()" class="ic-filter-back">
              <span class="selected-category">{{ serviceCategorySearchTerm }}</span>
            </a>
            <li *ngFor="let service of displayServiceCategory.serviceTotals" class="filter-services">
              <a
                (click)="filterByService(service.name)"
                [ngClass]="{
                  'filter-service': true,
                  selected: service.name === serviceSearchTerm && serviceDescriptionSelected === 'true',
                }">
                {{ service.name }} (<span>{{ service.total }}</span
                >)
              </a>
            </li>
          </ul>
          <ul *ngIf="!serviceCategorySearchTerm && displayTotals" class="plain-list">
            <li *ngFor="let serviceCategory of displayTotals.serviceCategoryTotals">
              <a (click)="filterByServiceCategory(serviceCategory.name)"
                >{{ serviceCategory.name }} <span>({{ serviceCategory.total }})</span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="search-results">
      <div class="sort-container">
        <div class="empty-container"></div>
        <span class="sort-text">Sort</span>
        <div class="select-dropdown-container">
          <ng-select
            (change)="sortChange()"
            appearance="outline"
            [searchable]="false"
            [clearable]="false"
            [(ngModel)]="selectedSort"
            [items]="sortRules">
          </ng-select>
        </div>
      </div>
      <hcf-search-result-detail
        *ngFor="let profile of profiles"
        [searchResult]="profile"
        [typeFilter]="selectedFilterType"
        [places]="placesForMap"
        (openPopupMap)="openPopupMap($event)">
      </hcf-search-result-detail>
      <a *ngIf="showMoreResults" (click)="getDataScroll()" class="btn-more-results">Show more results</a>
      <div *ngIf="isLoading" class="results-loading"></div>
      <div class="no-results" *ngIf="searchAttempted && !hasResults">
        <p class="no-results-text">{{ noResultsText }}</p>
        <ul>
          <li>
            <p>
              If you searched by person or healthcare facility, try searching by the type of healthcare service, service
              category or specialty instead e.g. gynaecology.
            </p>
          </li>
          <li>
            <p> Suggestions for results will appear in a drop-down menu as you start typing in the search bar. </p>
          </li>
          <li>
            <p>
              You can widen or narrow your search location by using the “Include nearby locations” slider in the filter
              panel options.
            </p>
          </li>
          <li><p>Try using a different search term or keyword(s).</p></li>
          <li>
            <p>
              If you're still unable to find what you need, please
              <a target="_blank" href="https://www.southerncross.co.nz/society/contact-us"> contact us</a>.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<hcf-popup #filterHelpPopupComponent>
  <hcf-filter-help-form></hcf-filter-help-form>
</hcf-popup>
